import type { HTMLAttributes, ReactNode } from 'react';

import useClassy from '@core/hooks/useClassy';

import classes from './style.module.scss';

interface KbdShortcutProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  className?: string;
  kind?: 'ghost' | 'outline';
}

const KbdShortcut = ({ children, className, kind = 'ghost', ...props }: KbdShortcutProps) => {
  const bem = useClassy(classes, 'KbdShortcut');

  return (
    <kbd aria-hidden="true" className={bem('&', `_${kind}`, className)} {...props}>
      {children}
    </kbd>
  );
};

export default KbdShortcut;
